import FinanceProduct from "../../../model/financeProduct/FinanceProduct";

/**
 * Finance products fetched action
 */
export const FINANCE_PRODUCTS_FETCHED = "FINANCE_PRODUCTS_FETCHED";
export type FINANCE_PRODUCTS_FETCHED = { products: FinanceProduct[] };

/**
 * Finance products sort order updated action
 */
export const FINANCE_PRODUCTS_SORT_ORDER_UPDATED = "FINANCE_PRODUCTS_SORT_ORDER_UPDATED";
export type FINANCE_PRODUCTS_SORT_ORDER_UPDATED = { products: FinanceProduct[] };

/**
 * Finance product created action
 */
export const FINANCE_PRODUCT_CREATED = "FINANCE_PRODUCT_CREATED";
export type FINANCE_PRODUCT_CREATED = { product: FinanceProduct };

/**
 * Finance product updated action
 */
export const FINANCE_PRODUCT_UPDATED = "FINANCE_PRODUCT_UPDATED";
export type FINANCE_PRODUCT_UPDATED = { product: FinanceProduct };